import { useState } from "react";
import { SubTaskPrompt, SubTaskRole, SubTaskStudent } from "../../interfaces/Task";
import Select from "react-select";
import { useTranslation } from "react-i18next";

export interface SiteSubTaskStudentProps {
    student: SubTaskStudent;
    saveCallback: CallableFunction;
    editCallback: CallableFunction;
    deleteCallback: CallableFunction;
    roles: SubTaskRole[];
    prompts: SubTaskPrompt[]
}

export default function SiteSubTaskStudent(props: SiteSubTaskStudentProps) {
    const { t } = useTranslation();

    const [showEdit, setShowEdit] = useState(false);

    const truncateMiddle = (text: string, maxLength: number = 12) => {
        if (text.length <= maxLength) return text;
        const start = Math.ceil((maxLength - 3) / 2);
        const end = Math.floor((maxLength - 3) / 2);
        return text.slice(0, start) + '...' + text.slice(-end);
    }

    const handleShowEdit = () => {
        props.editCallback();
        //setShowEdit(true);
    }

    const handleDelete = () => {
        if (window.confirm(t("Are you sure you want to delete the student? This action cannot be undone."))) {
            props.deleteCallback(props.student);
        }
    }

    const getRoleName = (position: number) => {
        const role = props.roles[position];
        if (role === undefined) {
            return '';
        } else {
            return role.name;
        }
    }

    const getRoleColor = (position: number) => {
        const role = props.roles[position];
        if (role === undefined) {
            return '#6c757d';
        } else {
            return role.color || '#6c757d';
        }
    }

    const getPromptName = (position: number) => {
        const prompt = props.prompts[position];
        if (prompt === undefined) {
            return '';
        } else {
            return prompt.name;
        }
    }

    return(
        <div className="site-sub-task-student-container" key={ 'sub-task-student-' + props.student._id }>
            <div className="student-data">
                <div className="actions">
                    <a className="edit-link" title={ t("Edit student") } onClick={ handleShowEdit }></a>
                    <a className="delete-link" title={ t("Delete student") } onClick={ handleDelete }></a>
                </div>
                <div className="name" title={ props.student.name }>
                    { truncateMiddle(props.student.name) }
                </div>
                <div className="meta">
                    { getRoleName(props.student.role).length > 0 &&
                        <div className="role text-truncate" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <span
                                style={{
                                    display: 'inline-block',
                                    width: '10px',
                                    height: '10px',
                                    borderRadius: '50%',
                                    backgroundColor: getRoleColor(props.student.role),
                                    flexShrink: 0
                                }}
                                title={t("Role color")}
                            ></span>
                            <span>{ 'R:'} { getRoleName(props.student.role) }</span>
                        </div>
                    }
                    { getPromptName(props.student.prompt).length > 0 &&
                        <div className="prompt text-truncate">
                            { 'P:'} { getPromptName(props.student.prompt) }
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}